module.exports = __webpack_public_path__ + "static/images/order-wfh.59f23c0.png";